'use strict'

var Marionette = require('marionette')
var App = require('app')
var DialogComponent = require('src/components/dialog-view')

/**
 * Dialog body view
 * -----------------------------------------------------------------------------
 * Body of the dialog
 */
var DialogBody = DialogComponent.Body.extend({
  template: require('./templates/body.html'),
  templateContext: function () {
    return {
      getDeviceTypes: App.TemplateHelpers.getDeviceTypes,
      getClients: App.TemplateHelpers.getClients,
      getUserRoles: App.TemplateHelpers.getUserRoles,
      getApiRoles: App.TemplateHelpers.getApiRoles,
      userHasRole: App.TemplateHelpers.userHasRole
    }
  }
})

/**
 * Dialog view
 * -----------------------------------------------------------------------------
 * The dialog view
 */
var DialogView = DialogComponent.Layout.extend({
  className: 'dialog dialog-api-key',
  onRender: function () {
    var bodyView = new DialogBody({model: this.model, collection: this.collection})
    this.showChildView('bodyRegion', bodyView)
  }
})

module.exports.Layout = DialogView



// WEBPACK FOOTER //
// ./js/modules/client-apikeys/edit_new/view.js